import React, { useState, useEffect } from 'react'
import { useAccess } from 'contexts/access'
import { useWhistleblowing } from 'contexts/whistleblowing'
import { useModal } from 'modals/dialog'
import CaseHandlers from './case-handlers'
import Portal from './portal'

const WhistleblowingSetUp = ({ rolesAdmin, onDone, ...props }) => {
    const { setSettingUp } = useWhistleblowing()
    const { showing } = useModal()

    const [step, setStep] = useState('case-handlers')
    const [grantedMyself, setGrantedMyself] = useState(false)

    useEffect(() => {
        if(showing) {
            setSettingUp(true)
        }

        return () => setSettingUp(false)
    }, [showing])

    if(step === 'portal') {
        return (
            <Portal
                {...props}
                onDone={() => onDone?.(grantedMyself)} />
        )
    }

    return (
        <CaseHandlers
            {...props}
            rolesAdmin={rolesAdmin}
            onDone={grantedMyself => {
                setGrantedMyself(grantedMyself)

                if(rolesAdmin) {
                    return void setStep('portal')
                }

                onDone?.(grantedMyself)
            }} />
    )
}

export default props => {
    const { check } = useAccess()
    const rolesAdmin = check('roles:manage')

    return (
        <WhistleblowingSetUp
            {...props}
            rolesAdmin={rolesAdmin} />
    )
}